let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jXH6M")).then(() => parcelRequire('fY2L4'));